// extracted by css-extract-rspack-plugin
export default {"label":"E7H0a"};